import React from 'react';
import StarterSetCartForm from '../cartforms/StarterSetCartForm';

import Text from '../common/Text';
import Gallery from '../sewpatgallery/SewpatGalleryEmbed';
import CouponBar from '../home/CouponBar';
import NewsLetterBar from '../home/NewsLetterBar';

const SewpatGallery = () => (
    <div>
        <Gallery />
        <Text.Divider margin='1.61em 0 0' />
        <NewsLetterBar />
        <StarterSetCartForm />
        <Text.Divider margin='1.61em 0 0' />
        <CouponBar />
    </div>
);

export default SewpatGallery;



// WEBPACK FOOTER //
// ./src/components/sewpatgallery/SewpatGallery.js